export const BITLY_ORG_KEY = 'bitly_org_id'
export const BitlyOrgTitle = 'Bitly Organization'

export const BitlyGroupTitle = 'Bitly Group'
export const BITLY_GROUP_KEY = 'bitly_group_id'

export const BitlyDomainTitle = 'Branded Short Domain'
export const BITLY_SHORTENED_URL = 'shortened_url'
export const BITLY_QR_CODE_ENABLED = 'qr_code_enabled'
export const BITLY_QR_CODE_CONFIG = 'qr_code_config'
export const BITLY_QR_CODE_USE_LONG_URL = 'qr_code_use_long_url'
export const BITLY_QR_CODE_DONT_REGENERATE = 'qr_code_dont_regenerate'
